// Settings model used by the Settings UI. These are client-side preferences
// until server endpoints are implemented.

export type SettingsModel = {
  account: {
    email: string;
    twoFactorEnabled: boolean;
  };
  // Reserved for future profile settings in UI; most profile fields
  // are edited directly via /users/me today
  profile: Record<string, never>;
  appearance: {
    theme: 'system' | 'light' | 'dark';
    background: 'graphite' | 'ink' | 'warm' | 'black' | 'tinted';
    accent: 'emerald' | 'blue' | 'purple' | 'rose' | 'amber' | 'indigo' | 'cyan' | 'orange';
    density: 'compact' | 'comfortable';
    quickEmojis: string[];
    showDrawerTabs: boolean;
  };
  notifications: {
    globalMute: boolean;
    perChannelDefault: 'all' | 'mentions' | 'none';
    desktop: boolean;
    mobile: boolean;
    desktopEnabled?: boolean;
    soundEnabled?: boolean;
    webPushEnabled?: boolean;
    mobilePushEnabled?: boolean;
    toneUrl?: string | null;
    mutedSpaces?: Record<string, boolean>;
    hiddenSpaces?: Record<string, boolean>;
  };
  privacy: {
    dmPermissions: 'everyone' | 'friends' | 'none';
    readReceipts: boolean;
  };
  // Placeholder for device/session UI
  devices: Record<string, never>;
  integrations: {
    githubConnected: boolean;
    notionConnected: boolean;
  };
  advanced: {
    developerLogs: boolean;
  };
};

export const defaultSettings: SettingsModel = {
  account: { email: '', twoFactorEnabled: false },
  profile: {},
  appearance: { theme: 'dark', background: 'graphite', accent: 'emerald', density: 'comfortable', quickEmojis: ['👍', '❤️', '🔥', '🎉', '😍', '👏'], showDrawerTabs: true },
  notifications: { globalMute: false, perChannelDefault: 'all', desktop: true, mobile: true },
  privacy: { dmPermissions: 'friends', readReceipts: true },
  devices: {},
  integrations: { githubConnected: false, notionConnected: false },
  advanced: { developerLogs: false },
};
